import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=5ee8be63&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"
import style1 from "./MessageCenter.vue?vue&type=style&index=1&id=5ee8be63&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee8be63",
  null
  
)

export default component.exports